import { post, fetch } from "../plugin/fetch";
export default {
    fetchGloble({ commit }) {
        //commit('SET_LOADER', true);
        return new Promise(() => {
            // console.log(post)
            fetch('/NewConfigs/GetList').then(res => {
                if (res.status) {
                    commit('SET_GLOBLE', res.data);
                    document.title = res.data.list.site_name
                    if (res.data && res.data.list && res.data.list.site_tongji) {
                        window._hmt = window._hmt || [];
                        var hm = document.createElement("script");
                        hm.id = "statitic";
                        hm.src = res.data.list.site_tongji;
                        var s = document.getElementsByTagName("script")[0];
                        s.parentNode.insertBefore(hm, s);
                    }
                } else {
                    //commit('SET_NOTIFICATION', { text:res.message ? res.message:'缺少必备参数！' });
                }
            });
        });
    },
    fetchPromotion({ commit }) {
        //commit('SET_LOADER', true);
        return new Promise(() => {
            fetch('/Videos/GetPsData').then(res => {
                if (res) {
                    console.log(res)
                    commit('SET_PROMOTION', res)
                } else {
                    //console.log(2)
                    commit('SET_NOTIFICATION', { text: res.message ? res.message : '缺少必备参数！' });
                }
            });
        });
    },
    fetchNavigator({ commit }) {
        //commit('SET_LOADER', true);
        return new Promise(() => {
            post('/Lists/list').then(res => {
                if (res.status) {
                    commit('SET_NAVIGATOR', res.data);
                } else {
                    //commit('SET_NOTIFICATION', { text:res.message ? res.message:'缺少必备参数！' });
                }
            });
        });
    },
    fetchHome({ commit }) {
        //commit('SET_LOADER', true);
        return new Promise(() => {
            post('/Videos/Index').then(res => {
                if (res.status) {
                    commit('SET_HOME', res.data);
                } else {
                    //commit('SET_NOTIFICATION', { text:res.message ? res.message:'缺少必备参数！' });
                }
            });
        });
    },
    fetchPlay({ commit }, payload) {
        //commit('SET_LOADER', true);
        return new Promise(() => {
            fetch('/Videos/Get', {
                vid: payload
            }).then(res => {
                if (res.status) {
                    commit('SET_PLAY', res.data);
                }
            });
        });
    },
    fetchCategory({ commit }, payload) {
        commit('FETCH_STATE', true);
        return new Promise(() => {
            fetch('/videos/GetVideoList', {
                ...payload
            }).then(res => {
                if (res.status) {
                    commit('SET_CATEGORY', res.data);
                }
                commit('FETCH_STATE', false);
            });
        });
    },
    fetchResultByKey({ commit }, payload) {
        //commit('SET_LOADER', true);
        //commit('FETCH_STATE', true);
        return new Promise(() => {
            fetch('/videos/GetSearch', {
                ...payload
            }).then(res => {
                if (res.status) {
                    commit('SET_RESULT', res.data);
                }
                //commit('FETCH_STATE', false);
            });
        });
    }
}